import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { TextField } from '@mui/material';
import moment from 'moment';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import useStyles from './styles';
export default function MonthRangeDatePicker(_ref) {
  let disabled = _ref.disabled,
    label = _ref.label,
    fromDate = _ref.fromDate,
    toDate = _ref.toDate,
    fromDateExternal = _ref.fromDateExternal,
    toDateExternal = _ref.toDateExternal,
    handleDateChange = _ref.handleDateChange,
    format = _ref.format;
  const classes = useStyles();
  const _useState = useState(fromDate ? moment(fromDate).toDate() : null),
    _useState2 = _slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  const _useState3 = useState(toDate ? moment(toDate).toDate() : null),
    _useState4 = _slicedToArray(_useState3, 2),
    endDate = _useState4[0],
    setEndDate = _useState4[1];
  const onChange = dates => {
    const _dates = _slicedToArray(dates, 2),
      start = _dates[0],
      end = _dates[1];
    if (handleDateChange) {
      handleDateChange(start, end);
    }
    if (fromDateExternal === undefined && toDateExternal === undefined) {
      setStartDate(start);
      setEndDate(end);
    }
  };
  const keyDownHandler = e => {
    const values = e.target.value.split('-');
    if (values && values.length == 2) {
      let newStartDate = Date.parse(values[0]);
      let newEndDate = Date.parse(values[1]);
      if (!isNaN(newStartDate) && !isNaN(newEndDate) && newStartDate <= newEndDate) {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.rangeDatePicker
  }, /*#__PURE__*/React.createElement(DatePicker, {
    disabled: disabled,
    selected: startDate,
    onKeyDown: keyDownHandler,
    onChange: onChange,
    startDate: fromDateExternal === undefined ? startDate : fromDateExternal,
    endDate: toDateExternal === undefined ? endDate : toDateExternal,
    selectsRange: true,
    showMonthYearPicker: true,
    dateFormat: format || 'MMM yyyy',
    customInput: /*#__PURE__*/React.createElement(TextField, {
      label: label || 'Months range',
      InputProps: {
        style: {
          paddingRight: '14px'
        },
        endAdornment: /*#__PURE__*/React.createElement(Icon, {
          type: "calendar-picker"
        })
      }
    })
  }));
}